import { IAttributes } from 'angular'

import { dateFormat } from '../../../filters/wr-date-format'

/**
 * Controller for the register closure info component.
 *
 * @class RegisterClosureInfoController
 */
export class RegisterClosureInfoController {
  public fields: $TSFixMe
  public registerClosure: $TSFixMe

  constructor(private $attrs: IAttributes) {
    'ngInject'
  }

  public $onChanges() {
    this._setFields()
  }

  public $postLink() {
    this.$attrs.$addClass('wr-info-fields register-closure-info-fields')
  }

  /**
   * Constructs and populates the info fields for the register closure
   *
   * @private
   * @method _setFields
   */
  private _setFields() {
    if (!this.registerClosure) {
      this.fields = []
      return
    }

    const outletTimeZone = this.registerClosure.outlet.time_zone
    const fields = [
      {
        label: 'Outlet',
        value: this.registerClosure.outlet.name,
      },
      {
        label: 'Register',
        value: this.registerClosure.register.name,
      },
      {
        label: 'Closure #',
        value: this.registerClosure.register_closure_sequence_number,
      },
      {
        label: 'Opening time',
        value: dateFormat(
          this.registerClosure.register_open_time,
          undefined,
          outletTimeZone
        ),
      },
    ]

    if (this.registerClosure.register_close_time) {
      fields.push({
        label: 'Closing time',
        value: dateFormat(
          this.registerClosure.register_close_time,
          undefined,
          outletTimeZone
        ),
      })
    }

    this.fields = fields
  }
}
